import React from "react";
import PT from "prop-types";
import { LightgalleryProvider , LightgalleryItem } from "react-lightgallery";

const PhotoItem = ({ image, thumb, group }) => (
  <div style={{ maxWidth: "450px", width: "400px", padding: "5px" }}>
    <LightgalleryItem group={group} src={image} thumb={thumb}>
      <img src={image} style={{ width: "100%" }} alt="Img gallery" />
    </LightgalleryItem>
  </div>
);
PhotoItem.propTypes = {
  image: PT.string.isRequired,
  thumb: PT.string,
  group: PT.string.isRequired,
};

export const GalleryImages = ({ images }) => {
  const listImages = images.map((item) => [item.image, item.image]);
  return (
    <div className="content">
      <div>
        <LightgalleryProvider lightgallerySettings = {{download:false, zoom:false,fullScreen:false }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {listImages.map((p, idx) => (
              <PhotoItem key={idx} image={p[0]} thumb={p[1]} group="group1" />
            ))}
          </div>
        </LightgalleryProvider>
      </div>
    </div>
  );
};
